import { resolveDocLinks } from '../../../../genui/components/DocLinkBlock/docLinkBlock.utils';
import { DocLink, DocLinkBlock, VizBlock } from '../../../../genui/viz.types';

const isDocLinkBlock = (block: VizBlock): block is DocLinkBlock => block.kind === 'doc-link';

const dedupeByUrl = (links: DocLink[]): DocLink[] => {
  const seenUrls = new Set<string>();

  return links.filter((link) => {
    if (seenUrls.has(link.url)) {
      return false;
    }

    seenUrls.add(link.url);
    return true;
  });
};

/**
 * A rachel pode consultar o glossário mais de uma vez na mesma mensagem, e cada consulta
 * devolve o próprio bloco de documentação. Renderizados um a um, o rótulo "veja mais em"
 * se repete — então os links de todos eles viram um bloco só, no fim da mensagem.
 */
export const collectDocLinkBlock = (blocks: VizBlock[]): DocLinkBlock | undefined => {
  const docLinkBlocks = blocks.filter(isDocLinkBlock);

  if (docLinkBlocks.length === 0) {
    return undefined;
  }

  const links = dedupeByUrl(docLinkBlocks.flatMap(resolveDocLinks));

  if (links.length === 0) {
    return undefined;
  }

  return { ...docLinkBlocks[0], links, url: undefined };
};

export const withoutDocLinks = (blocks: VizBlock[]): VizBlock[] =>
  blocks.filter((block) => !isDocLinkBlock(block));
